import {Component, OnInit, Inject, OnChanges, OnDestroy} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {SliderModelService} from './../../../services/infrastructure/sliderModel.service';
import {GrowerOrderService} from './../../../services/seed/growerOrder.service';
import {ConfirmDialogComponent} from './../../../common/components/confirm-dialog/confirm-dialog.component';
import {GrowerOrderItemVM} from '../../../models/GrowerOrderItemVM';
import {LoaderService} from './../../../services/infrastructure/loader.service';
import {DashboardFilter} from './../../../models/DashboardFilter';
import {BroadcastService} from '././../../../services/infrastructure/broadcaster.service';
import {ConfigService} from '././../../../services/infrastructure/config.service';
import {GrowerOrderTransferVM} from '../../../models/GrowerOrderTransferVM';
import {OrderTransferService} from '././../../../services/seed/order-transfer.service';
import {Router} from '@angular/router';
import {LocalStorageService} from './../../../services/infrastructure/local-storage.service';
import {MasterConstants} from '../../constants/master-constants';
import {AccountVM} from './../../../models/AccountMasterVM';
import {ToastrService} from 'ngx-toastr';
import {CommonService} from './../../../services/common/common.service';
import {Subscription} from 'rxjs';
import {LolLoggerService} from './../../../common/shared/lol-logger.service';

@Component({
  selector: 'app-grower-order-transfer',
  templateUrl: './grower-order-transfer.component.html',
  styleUrls: ['./grower-order-transfer.component.scss']
})

export class GrowerOrderTransferComponent implements OnInit, OnChanges, OnDestroy {
  private subscription = new Array<Subscription>();
  public AccountId: any;
  orderFromTo: GrowerOrderTransferVM = null;
  changeListDS: GrowerOrderItemVM[];
  orderFromToList: GrowerOrderTransferVM[] = [];
  fromGrower: any;
  toGrower: any;
  accountLoading: any;
  accountEmail: any;
  emailPattern: any = MasterConstants.EMAIL_PATTERN;
  accountInfo: AccountVM;
  individualEmailPattern: any = MasterConstants.INDIVIDUAL_EMAIL_PATTERN;
  // component variables at component initialize
  copyOrderFromToList: GrowerOrderTransferVM[] = [];
  isTransfer = false;
  GrowerSearchSliderActive = false;
  sellerData: any;
  growerList: any[];
  toGrowerList: any[];
  public dashboardFilter: DashboardFilter;

  headerYear: any;
  headerCompany = MasterConstants.US_COMPANYCODE;
  toSellerId: any;
  selectedGrower: string;
  originalUnitCount = 0;
  modifiedUnitCount = 0;
  public SelectedAccountId: any;
  hasChangeAdded = false;
  isNotValid = false;
  errorMsgs = new Array();
  isSubscriptionAccess = true;

  constructor(
    public sliderModelService: SliderModelService,
    public matDialog: MatDialog,
    public loaderService: LoaderService,
    private router: Router,
    private growerOrderService: GrowerOrderService,
    private toastrService: ToastrService,
    public broadcastService: BroadcastService,
    private configService: ConfigService,
    private orderTransferService: OrderTransferService,
    private localStorageService: LocalStorageService,
    public commonService: CommonService,
    @Inject('BASE_URL') public baseUrl: any) {
    this.dashboardFilter = new DashboardFilter();
    this.subscription.push(this.broadcastService.on<any>(this.configService.DATA_CHANGE_ADDED).subscribe((data) => {
      if (data.hasChangeAdded != undefined) {
        this.hasChangeAdded = data.hasChangeAdded;
      }
    }));

    // subscribe GMk value from grower search
    this.subscription.push(this.sliderModelService.gmkValue.subscribe(x => {
      if (x != 0) {
        this.selectedGrower = x;
        this.getGrowerAccount(this.AccountId);
        // to fix multiple times slider open issue
        // this.sliderModelService.gmkValue.observers = [];
      }
    }));
  }

  ngOnChanges() {
    this.GetSellerList();
  }

  validateEmail() {
    this.isNotValid = this.commonService.validateEmail(this.accountEmail, true);
    this.broadcastService.broadcast(this.configService.DATA_CHANGE, {emailUpdated: true});
    if (!this.isNotValid) {
      this.copyOrderFromToList.forEach(x => {
        x.EmailTo = this.accountEmail;
      });
    }
    return this.isNotValid;
  }

  ngOnInit() {
    // load header crop year and company code
    if (this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR)) {
      this.headerYear = JSON.parse(this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR));
    }

    this.subscription.push(this.sliderModelService.selectedGrowerAccId.subscribe(x => {
      this.AccountId = +x;
    }));

    this.subscription.push(this.sliderModelService.SelectedAccountId.subscribe(x => {
      this.SelectedAccountId = +x;
    }));

    if (this.localStorageService.get(MasterConstants.EVOLVE_ACCESS)) {
      const data = JSON.parse(this.localStorageService.get(MasterConstants.EVOLVE_ACCESS));
      if (data !== null && data !== undefined && data.resultData.length > 0) {
        const isActiveUser = data.resultData.find(x => x.userIdCompanyCode == this.headerCompany);
        if (!isActiveUser.isSubscriptionAccess) {
          this.isSubscriptionAccess = false;
          this.accountEmail = isActiveUser.emailId;
        } else {
          this.isSubscriptionAccess = true;
        }
      }
    }

    this.subscription.push(this.sliderModelService.g2gUnit.subscribe(x => {
      this.bindOrderTransferList(x);
    }));

    this.sliderModelService.g2gUnit.observers = [];

    this.GetSellerList();
    // If header dropdown value exist
    if (this.headerCompany && this.headerYear) {
      this.getGrowerAccount(this.AccountId);
      this.getAccountInfo(this.AccountId);
    }
  }

  // Get Account Info
  getAccountInfo(accountNumber: number) {
    this.subscription.push(this.growerOrderService.getAccounts().subscribe((results: any[]) => {
      const objList = results.filter(x => x.accountNumber == accountNumber);
      for (const obj of objList) {
        this.accountInfo = obj;
      }
    }, error => { LolLoggerService.error(error); }));
  }

  selectToGrowerGMK(toGrower) {
    if (toGrower) {
      this.toGrower = toGrower;
      this.isTransfer = true;
    }
  }
  // Get All seller list
  GetSellerList() {
    this.subscription.push(this.growerOrderService.getSellerList(this.AccountId.toString()).subscribe(result => {
      this.sellerData = result;
    }, error => { LolLoggerService.error(error); }));
  }

  // Search Seller function
  public sellerSearchFn(term: string, item: any) {
    if (term) {
      term = term.toLocaleLowerCase();
    }
    
    return (item.accountName == null ? false : item.accountName.toLocaleLowerCase().indexOf(term) > -1)
      || (item.accountNumber == null ? false : item.accountNumber.toString().indexOf(term) > -1)
      || (item.address1 == null ? false : item.address1.toLocaleLowerCase().indexOf(term) > -1)
      || (item.city == null ? false : item.city.toLocaleLowerCase().indexOf(term) > -1)
      || (item.state == null ? false : item.state.toLocaleLowerCase().indexOf(term) > -1)
      || (item.zipCode == null ? false : item.zipCode.toLocaleLowerCase().indexOf(term) > -1);
  }

  // get call on seller change
  SellerChange($event) {
    if ($event != null && $event.accountNumber > 0) {
      this.toSellerId = $event.accountNumber;
      this.copyOrderFromToList.forEach(x => {
        if (this.toSellerId > 0) {
          x.ToSellerId = this.toSellerId;
        }
      });
    }
    else {
      this.toSellerId = null;
    }
    this.broadcastService.broadcast(this.configService.DATA_CHANGE, {sellerUpdate: true});
  }

  // filter function
  public accountSearchFn(term: string, item: any) {
    term = term.toLocaleLowerCase();
    return item.growerName.toLocaleLowerCase().indexOf(term) > -1;
  }

  toGrowerSearchFn(term: string, item: any) {
    if (term) {
      term = term.toLocaleLowerCase();
    }
    // TODO: Sumit - GMK
    return (item.businessName == null ? false : item.businessName.toLocaleLowerCase().indexOf(term) > -1)
      || (item.firstName == null ? false : item.firstName.toLocaleLowerCase().indexOf(term) > -1)
      || (item.lastName == null ? false : item.lastName.toLocaleLowerCase().indexOf(term) > -1)
      || (item.growerGLN == null ? false : item.growerGLN.toString().indexOf(term) > -1)
      || (item.gmk == null ? false : item.gmk.toString().indexOf(term) > -1)
      || (item.address1 == null ? false : item.address1.toLocaleLowerCase().indexOf(term) > -1)
      || (item.city == null ? false : item.city.toLocaleLowerCase().indexOf(term) > -1)
      || (item.state == null ? false : item.state.toLocaleLowerCase().indexOf(term) > -1)
      || (item.zip == null ? false : item.zip.toLocaleLowerCase().indexOf(term) > -1)
      || (item.primaryPhoneNumber == null ? false : item.primaryPhoneNumber.toLocaleLowerCase().indexOf(term) > -1);
  }

  // get grower List
  getGrowerAccount(accountNo: number) {
    if (!isNaN(accountNo)) {
      this.dashboardFilter.cropYear = this.headerYear;
      this.dashboardFilter.shipToAccount = +accountNo;
      const growerFilters = {'GrowerGLN': '', 'GrowerName': ''};
      this.subscription.push(this.growerOrderService.getGrowerListByFilter(this.dashboardFilter, growerFilters).subscribe(result => {
        this.growerList = result as any[];
        if (this.growerList && this.growerList.length > 0) {
          // TODO: Sumit - GMK
          this.growerList.forEach(grower => {
            grower.businessName = (grower.businessName == null || grower.businessName == '' ?
              (grower.firstName != null && grower.firstName != '' ? grower.firstName : '') +
              (grower.middleName != null && grower.middleName != '' ? ' ' + grower.middleName : '') +
              (grower.lastName != null && grower.lastName != '' ? ' ' + grower.lastName : '')
              : grower.businessName);
          });

          // add for auto select from search grower slider
          if (this.sliderModelService.GrowerSearchSliderActive.value) {
            const data = this.growerList.filter(x => x.gmk == this.selectedGrower);
            if (data[0]) {
              this.selectToGrower(data[0]);
            }
          }
          this.sliderModelService.GrowerSearchSliderActive.next(false);

          this.toGrowerList = this.growerList.filter(x => x.gmk != this.copyOrderFromToList[0].FromGMK || (x.gmk === this.copyOrderFromToList[0].FromGMK && x.growerOrderList[0].orderNumber != this.copyOrderFromToList[0].FromOrderNo));
          this.fromGrower = this.growerList.find(x => x.gmk === this.copyOrderFromToList[0].FromGMK && x.growerOrderList[0].orderNumber === this.copyOrderFromToList[0].FromOrderNo);
        }
      }, error => LolLoggerService.error(error)));
    }
  }

  // Qty change on +/- sign click
  geuValueChange(action: string, productItem: any) {
    const g2gItem = this.copyOrderFromToList.find(x => x.rowId == productItem.rowId);
    const index = this.copyOrderFromToList.findIndex(x => x.rowId == productItem.rowId);
    if (g2gItem && index != -1) {
      if (action == 'decrease') {
        if ((+productItem.ToPrimaryQty) > (+productItem.OriginalFromQty)) {
          productItem.ToPrimaryQty = productItem.OriginalFromQty;
        }
        else {
          if ((Math.ceil(+productItem.ToPrimaryQty / +productItem.Conv) * productItem.Conv - productItem.Conv) >= 0) {
            const valueBeforeDec = +productItem.ToPrimaryQty;
            productItem.ToPrimaryQty = Math.floor(+productItem.ToPrimaryQty / +productItem.Conv) * +productItem.Conv;
            // update correct values to variable after rounding to conv factor
            const conValue = Math.abs((+productItem.ToPrimaryQty) - (+productItem.Conv));
            if (+productItem.OriginalFromQty >= conValue && +productItem.OriginalFromQty < +productItem.Conv) {
              productItem.ToPrimaryQty = +productItem.OriginalFromQty;
            }
            else if (valueBeforeDec == +productItem.ToPrimaryQty) {
              // decrease value for ToDealer
              productItem.ToPrimaryQty = Math.abs((+productItem.ToPrimaryQty) - (+productItem.Conv));
            } else {
              productItem.ToPrimaryQty = Math.abs((+productItem.ToPrimaryQty));
            }
            productItem.ToQty = +productItem.ToPrimaryQty;
            // Scenario to handle when switching of value is done from manual entering and button pressing remaining quantity differ
            if (+productItem.FromPrimaryQty > 0 && (+productItem.FromPrimaryQty % (+productItem.Conv) == 0)) {
              // increase value for FromDealer
              productItem.FromPrimaryQty = Math.abs((+productItem.FromPrimaryQty) + (+productItem.Conv));
              productItem.FromQty = +productItem.FromPrimaryQty;
            } else {
              productItem.FromPrimaryQty = Math.abs((+productItem.OriginalFromQty) - (+productItem.ToPrimaryQty));
              productItem.FromQty = +productItem.FromPrimaryQty;
            }

            // update to show modified units
            if (productItem.ToPrimaryQty > 0) {
              productItem.FromModifyQty = productItem.FromPrimaryQty;
            }
            else {
              productItem.FromModifyQty = 0;
            }
          }
        }
        productItem.FromPrimaryQty = Math.abs((+productItem.OriginalFromQty) - (+productItem.ToPrimaryQty));
        productItem.FromQty = +productItem.FromPrimaryQty;
      }

      if (action == 'increase') {
        if (+productItem.OriginalFromQty <= +productItem.ToPrimaryQty) {
          productItem.ToPrimaryQty = +productItem.OriginalFromQty;
        }
        else if (+productItem.FromPrimaryQty > 0 && (((+productItem.FromPrimaryQty) - (+productItem.Conv) >= 0) ||
          (Math.ceil(+productItem.ToPrimaryQty / +productItem.Conv) * +productItem.Conv <= +productItem.OriginalFromQty)) && +productItem.FromPrimaryQty % (+productItem.Conv) == 0) {
          var valueBeforeInc = +productItem.ToPrimaryQty;

          productItem.ToPrimaryQty = Math.ceil(+productItem.ToPrimaryQty / +productItem.Conv) * +productItem.Conv;
          // update correct values to variable after rounding to conv factor
          if (valueBeforeInc == +productItem.ToPrimaryQty) {
            // increase value for ToGrower
            productItem.ToPrimaryQty = Math.abs((+productItem.ToPrimaryQty) + (+productItem.Conv));
          }
          else {(valueBeforeInc > +productItem.ToPrimaryQty);}
          {
            productItem.ToPrimaryQty = Math.abs((+productItem.ToPrimaryQty));
          }

          productItem.ToQty = +productItem.ToPrimaryQty;
        }
        else if (+productItem.OriginalFromQty >= +productItem.ToPrimaryQty) {
          var valueBeforeInc = +productItem.ToPrimaryQty;
          const convValue = Math.floor(+valueBeforeInc / +productItem.Conv);

          if (valueBeforeInc < +productItem.Conv && +productItem.OriginalFromQty < +productItem.Conv) {
            productItem.ToPrimaryQty = +productItem.OriginalFromQty;
          }
          else if (valueBeforeInc < +productItem.Conv && +productItem.OriginalFromQty > +productItem.Conv) {
            productItem.ToPrimaryQty = +productItem.Conv;
          }
          else {
            if (+productItem.FromPrimaryQty % (+productItem.Conv) != 0 && valueBeforeInc >= +productItem.Conv) {
              if (valueBeforeInc % +productItem.Conv == 0) {
                productItem.ToPrimaryQty = Math.abs((+productItem.ToPrimaryQty) + (+productItem.Conv));
              }
              else {
                productItem.ToPrimaryQty = +productItem.Conv * +convValue;
              }
            }
            else {
              productItem.ToPrimaryQty = +productItem.Conv * +convValue;
            }
          }

          productItem.ToPrimaryQty = Math.abs((+productItem.ToPrimaryQty));
          productItem.ToQty = +productItem.ToPrimaryQty;
        }
        productItem.FromPrimaryQty = Math.abs((+productItem.OriginalFromQty) - (+productItem.ToPrimaryQty));
        productItem.FromQty = +productItem.FromPrimaryQty;
        productItem.FromModifyQty = +productItem.FromPrimaryQty;
      }

      this.validateLineItem(productItem, 'growerUnits');
      this.copyOrderFromToList[index] = JSON.parse(JSON.stringify(productItem));
      // calculat total unit transfer
      this.calculateTotalUnitTransfer();
      this.broadcastService.broadcast(this.configService.DATA_CHANGE, {productCount: this.copyOrderFromToList.length});
    }
  }

  validateSelectedCount(element, g2gUnits: number) {
    const g2gItem = this.copyOrderFromToList.find(x => x.rowId == element.rowId);
    const index = this.copyOrderFromToList.findIndex(x => x.rowId == element.rowId);
    if (g2gItem && index != -1) {
      // update ToGrower qty
      g2gItem.ToPrimaryQty = +g2gUnits;
      g2gItem.ToQty = +g2gUnits;

      g2gItem.FromPrimaryQty = +g2gItem.OriginalFromQty - (+g2gUnits);
      g2gItem.FromQty = +g2gItem.FromPrimaryQty;

      if (g2gItem.FromPrimaryQty < 0) {
        g2gItem.FromPrimaryQty = 0;
        g2gItem.FromQty = 0;
      }

      this.validateLineItem(g2gItem, 'growerUnits');
      this.copyOrderFromToList[index] = JSON.parse(JSON.stringify(g2gItem));

      this.calculateTotalUnitTransfer();
    }
  }

  bindOrderTransferList(orderList) {
    // initial data binding
    this.orderFromToList = [];
    orderList.forEach(item => {
      // To get only date part
      let desiredDate = item.desiredDeliveryDate.toString();
      desiredDate = desiredDate.substring(0, 10);

      this.orderFromTo = new GrowerOrderTransferVM();
      this.orderFromTo.CropYear = this.headerYear;
      this.orderFromTo.CompanyCode = this.headerCompany;
      this.orderFromTo.FromShipToAccount = item.shipToAccount;
      this.orderFromTo.ToShipToAccount = item.shipToAccount;
      this.orderFromTo.ItemId = item.itemID;
      this.orderFromTo.ItemNumber = item.itemNumber;
      this.orderFromTo.ItemDescription = item.itemDescription;
      this.orderFromTo.Brand = item.brand;
      this.orderFromTo.MarketingBrand = item.marketingBrand;
      this.orderFromTo.OriginalFromQty = item.geu;
      this.orderFromTo.FromModifyQty = 0;
      this.orderFromTo.FromPrimaryQty = item.geu;
      this.orderFromTo.FromDeliveryDate = desiredDate;
      this.orderFromTo.FromCustomerPO = item.customerPO;
      this.orderFromTo.FromGMK = item.growerGMK;
      this.orderFromTo.FromOrderId = item.growerOrderID;
      this.orderFromTo.FromOrderItemId = item.growerOrderItemId;
      this.orderFromTo.FromOrderNo = item.growerOrderNumber;
      this.orderFromTo.PrimaryUom = item.primaryUOM;
      this.orderFromTo.Conv = item.conv;
      this.orderFromTo.ToPrimaryQty = 0;
      this.orderFromTo.ToSecondaryQty = 0;
      this.orderFromTo.ToQty = 0;
      this.orderFromTo.rowId = item.rowId;
      this.orderFromTo.ToOrderId = 0;
      this.orderFromTo.ToOrderNo = '';
      this.orderFromTo.ToSellerId = 0;
      this.orderFromTo.ToCustomerPO = '';
      this.orderFromTo.ToDeliveryDate = desiredDate;
      this.orderFromTo.LineErrors = item.lineErrors;
      this.orderFromTo.FromChangeType = 'TGF';
      this.orderFromTo.ToChangeType = 'TGT';
      this.orderFromTo.EmailTo = this.accountEmail;
      this.orderFromTo.seedNonReturnable = item.seedNonReturnable;
      this.orderFromToList.push(this.orderFromTo);
    });

    this.cloneTransferListObj(this.orderFromToList);
    this.calculateTotalUnitTransfer();
  }

  cloneTransferListObj(orderList) {
    this.copyOrderFromToList = JSON.parse(JSON.stringify(orderList));
  }

  individualEmailValidation() {
    const emailList = this.accountEmail.split(';');
    let isValid = false;
    if (emailList.length > 0) {
      emailList.map((x) => {
        if (this.individualEmailPattern.test(x)) {
          isValid = true;
        }
        else {
          isValid = false;
        }
      });
    }
    if (!isValid) {
      this.toastrService.error('Enter a valid email.');
      return false;
    }
    else {
      return true;
    }
  }

  transferUnits() {
    if (!this.validateEmail()) {
      if (this.copyOrderFromToList.filter(x => x.ToPrimaryQty != 0).length > 0) {
        if (this.validateG2GTransfer()) {
          this.copyOrderFromToList[0].EmailTo = this.accountEmail;
          this.loaderService.setLoaderStatus(true);
          this.subscription.push(this.orderTransferService.transferGrowerOrder(this.copyOrderFromToList.filter(x => x.ToPrimaryQty != 0)).subscribe((result: any) => {
            this.toastrService.success('Your order has been saved');
            this.broadcastService.broadcast(this.configService.DATA_CHANGE, {updateButtonClick: true});
            this.sliderModelService.close();
            this.loaderService.setLoaderStatus(false);
            this.router.navigate(['/orders/grower-order-detail', this.SelectedAccountId, +result]);
          }, (error => {
            this.loaderService.setLoaderStatus(false);
            LolLoggerService.error(error);
          })));
        }
      }
    }
    else {
      this.toastrService.warning('Enter a valid email.');
    }
  }

  validateG2GTransfer() {
    return true;
  }

  calculateTotalUnitTransfer() {
    this.originalUnitCount = this.copyOrderFromToList.reduce((sum, item) => sum + +item.OriginalFromQty, 0);
    this.modifiedUnitCount = this.copyOrderFromToList.reduce((sum, item) => sum + +item.ToPrimaryQty, 0);
  }

  selectToGrower(toGrower) {
    if (toGrower) {
      this.toGrower = toGrower;
      this.isTransfer = true;
      this.copyOrderFromToList.forEach(x => {
        x.ToGLN = toGrower.growerGLN;
        x.ToGMK = toGrower.gmk;
        if (toGrower.growerOrderList.length > 0) {
          x.ToOrderId = toGrower.growerOrderList[0].growerOrderID;
          x.ToOrderNo = toGrower.growerOrderList[0].orderNumber;
        }
      });
    }
    else {
      this.toGrower = null;
      this.isTransfer = false;
    }
    this.broadcastService.broadcast(this.configService.DATA_CHANGE, {transferTarget: true});
  }

  onCancel() {
    if (this.hasChangeAdded) {
      const title = 'Leave without saving?';
      const message = '';
      const dialogRef = this.matDialog.open(ConfirmDialogComponent, {
        disableClose: true,
        width: '480px',
        data: {title: title, message: message, labelYes: 'Yes', labelNo: 'No, go back to Order', dialogType: 'confirm'}
      });
      this.subscription.push(dialogRef.afterClosed().subscribe(result => {
        if (result == true) {
          this.broadcastService.broadcast(this.configService.DATA_CHANGE, {cancelBtnClick: true});
          this.sliderModelService.close();
        }
      }));
    }
    else { this.sliderModelService.close(); }
  }

  openSearchGrowerSlider() {
    this.sliderModelService.GrowerSearchSliderActive.next(true);
    this.subscription.push(this.sliderModelService.GrowerSearchSliderActive.subscribe(data => {
      this.GrowerSearchSliderActive = data;
    }));

    this.sliderModelService.newGrowerOrderSliderClose.next(true);
    /*this.sliderModelService.growerSearchType.next('SAME_DEALER_TFR');*/
    this.sliderModelService.toAccountNumber.next(this.accountInfo.accountNumber);
  }

  // Line item validation
  validateLineItem(item: any, validateField) {
    if (validateField != '') {
      if (validateField == 'growerUnits') {
        if (+item.OriginalFromQty - +item.ToPrimaryQty < 0) {
          item.LineErrors.errors = item.LineErrors.errors.filter(y => y.id != 'growerUnits');
          item.LineErrors.errors.push({
            id: 'growerUnits', error: 'Cannot increase the quantity more than transferable units. '
          });
        }
        else {
          item.LineErrors.errors = item.LineErrors.errors.filter(y => y.id != 'growerUnits');
          this.errorMsgs = this.errorMsgs.filter(x => x.rowId != item.rowId);
        }
      }
    }
    if (item.LineErrors.errors.length > 0) {
      this.errorMsgs = this.errorMsgs.filter(x => x.rowId != item.rowId);
      this.errorMsgs.push(item.LineErrors);
    }
    if (this.errorMsgs.length > 0) {
      this.isTransfer = false;
    }
    else if (this.toGrower) {
      this.isTransfer = true;
    }
    else {
      this.isTransfer = false;
    }
    return item;
  }

  ngOnDestroy() {
    this.subscription.forEach(subscription => subscription.unsubscribe());
  }
}
